import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { PreviewAttachmentsViewComponent } from './preview-attachments-view/preview-attachments-view.component';
import { PreviewAttachmentsRoutingModule } from './preview-attachments-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';


@NgModule({
  declarations: [
    PreviewAttachmentsViewComponent,
    SafeUrlPipe
  ],
  imports: [
    CommonModule,
    PreviewAttachmentsRoutingModule,
    MatTableModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    FormsModule
  ]
})
export class PreviewAttachmentsModule { }
